import { render, staticRenderFns } from "./AddNewPermission.vue?vue&type=template&id=9554fac0&"
import script from "./AddNewPermission.vue?vue&type=script&lang=js&"
export * from "./AddNewPermission.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports